export default __webpack_public_path__ + "static/media/CalendarCross.a19932d2.svg";